export default __webpack_public_path__ + "static/media/Thomas@2x.a2773798.jpg";